/**
 * Telefone para infRespTec (NF-e): aceita +55/55 + DDD + número (como types.phone)
 * ou formato nacional com zero opcional antes do DDD (ex.: 01930148080), comum em cadastros.
 */
export default function ()
{
	const ddd = '(?:1[1-9]|2[1247]|3[1234578]|4[1-9]|5[1345]|6[1-9]|7[134579]|8[1-9]|9[1-9])';
	const midSuf = '([2-9]\\d{3,4})(\\d{4})';
	return {
		regex: new RegExp(
			`^(?:\\+?(55)(${ddd})${midSuf}|0?(${ddd})${midSuf})$`
		),
		filter: /[\(\)\-\s.]/g,
		store_mask(match, cc, ddd1, mid1, suf1, ddd2, mid2, suf2)
		{
			if (cc)
				return `${cc}${ddd1}${mid1}${suf1}`;
			return `${ddd2}${mid2}${suf2}`;
		},
		display_mask(match, cc, ddd1, mid1, suf1, ddd2, mid2, suf2)
		{
			if (cc)
				return `+${cc} (${ddd1}) ${mid1}-${suf1}`;
			return `(${ddd2}) ${mid2}-${suf2}`;
		}
	};
}
